import { useState } from "react";
import FaiBox from "../../../../MuiComponents/FaiBox";
import FaiTypography from "../../../../MuiComponents/FaiTypography";
import theme from "../../../../assets/theme";
import { Form, Formik, FormikProps } from "formik";
import { Grid, Icon, IconButton } from "@mui/material";
import FormField from "../../../../components/FormField";
import FaiButton from "../../../../MuiComponents/FaiButton";
import FaiSelect from "../../../../MuiComponents/FaiSelect";
import DashboardIlustration from "../../../../assets/images/illustrations/dashboard.png";
import { useNavigate } from "react-router-dom";
interface InitialObject {
    bankName: string;
    accountNo: string;
    accountHolderName: string;
    ifscCode: string;
    accountType: string;
}
function ApplicationUnderProcess() {
    const navigate = useNavigate();
    const { typography, palette, borders } = theme;
    const [initialObject, setInitialObject] = useState<InitialObject>({
        bankName: "",
        accountNo: "",
        accountHolderName: "",
        ifscCode: "",
        accountType: ""
    });

    return (
        <>
            <FaiBox>


                <FaiBox bgColor={palette.white.main} className={"coupon-form-content"} mt={"40px"} p={"80px"}
                    borderRadius={borders.borderRadius.md}
                    verticalAlign="middle">
                    <Grid container spacing={2} style={{ "alignItems": "center" }}>
                        <Grid item xs={12} sm={6} spacing={5}>
                            <h3>
                                Your Application is under Review
                            </h3>
                            <FaiTypography>
                                Our team is currently verifying your information and documents to approve your request.
                                <br>
                                </br>
                                <br>
                                </br>In the meantime, you can start adding products to your inventory. Once your application is approved, your inventory will go live.
                            </FaiTypography>
                            <FaiBox>

                                <FaiButton mt={"60px"}
                                    color="primary"
                                    variant={"contained"}
                                    fullWidth
                                    onClick={() => navigate('/app/catalog/add-product')}
                                >
                                    Add Product
                                </FaiButton>
                            </FaiBox>

                        </Grid>


                        <Grid item xs={12} sm={6}>
                            <FaiBox component={"img"} width="100% !important"
                                height="auto !important" src={DashboardIlustration} />


                        </Grid>
                    </Grid>



                </FaiBox>

            </FaiBox>
        </>
    )
}
export default ApplicationUnderProcess;